'use client';
import { TRADE_DISCOUNT_PERCENT } from 'helpers/constants/tradeAccount';
import useTradeAccount from 'helpers/hooks/useTradeAccount';
import { cn } from 'helpers/utils/classnames';

interface TradeAccountBannerProps {
  className?: string;
}

const TradeAccountBanner = ({ className }: TradeAccountBannerProps) => {
  const { isTradeAccount } = useTradeAccount();

  if (!isTradeAccount) return null;

  return (
    <div
      id="tradeAccountNoticeBanner"
      role="status"
      data-testid="trade-account-banner"
      className={cn(
        'relative inset-x-1/2 -mx-[50vw] w-screen bg-[#e7e1d4] p-4 text-center font-body text-[15px] text-[#203042]',
        className,
      )}
    >
      Your {TRADE_DISCOUNT_PERCENT}% Trade Discount will be automatically applied to eligible items in your cart, if
      applicable.
    </div>
  );
};

export default TradeAccountBanner;
